import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Encyclopedie from './pages/Encyclopedie';
import FichePierre from './pages/FichePierre';
import Blog from './pages/Blog';
import Article from './pages/Article';
import APropos from './pages/APropos';
import Glossaire from './pages/Glossaire';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/encyclopedie" element={<Encyclopedie />} />
          <Route path="/pierre/:id" element={<FichePierre />} />
          <Route path="/guides" element={<Blog />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/glossaire" element={<Glossaire />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;